import React, { Fragment, createContext, useState } from 'react';
import styles from './AcfFilteredList.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { FormButton, FormInput } from '@/components';
import formatUrlPath from '@/helpers/formatUrlPath';

let cx = className.bind(styles);

export const FilteredListContext = createContext([]);

export default function AcfFilteredList(props) {
	const { attributes, filteredList, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];
	const [selectedSlugs, setSelectedSlugs] = useState(filteredList.allowMultipleFilters ? [] : ['all']);

	function handleButtonClick(e) {
		if (filteredList.allowMultipleFilters) {
			if (selectedSlugs.includes(formatUrlPath(e.target.dataset.slug))) {
				const itemIndex = selectedSlugs.indexOf(formatUrlPath(e.target.dataset.slug));
				setSelectedSlugs(selectedSlugs.toSpliced(itemIndex, 1));
			} else {
				setSelectedSlugs([...selectedSlugs, formatUrlPath(e.target.dataset.slug)]);
			}
		} else {
			setSelectedSlugs([formatUrlPath(e.target.dataset.slug)]);
		}
	}

	return (
		<FilteredListContext.Provider value={selectedSlugs}>
			<div id={attributes.anchor} className={cx(['ns_filtered-list', 'filtered-list', ...className])} style={{ '--filtered-list-item-cols-mobile': filteredList.columns.mobile, '--filtered-list-item-cols-desktop': filteredList.columns.desktop }}>
				<div className={cx(['filtered-list-buttons'])}>
					{!filteredList.allowMultipleFilters && (
						<FormButton className={cx(['filtered-list-button', selectedSlugs.includes('all') && 'selected'])} outlined="true" data-slug="all" onClick={(e) => handleButtonClick(e)}>
							All
						</FormButton>
					)}
					{filteredList.filterButtons.map((button, index) => (
						<Fragment key={index}>            
							{(button.label && button.slug) && <FormButton className={cx(['filtered-list-button', selectedSlugs.includes(formatUrlPath(button.slug)) && 'selected'])} outlined="true" data-slug={formatUrlPath(button.slug)} onClick={(e) => handleButtonClick(e)}>
								{button.label}
							</FormButton>}
						</Fragment>
					))}
				</div>
				<div className={cx(['filtered-list-items', attributes.alignContent && `align-${attributes.alignContent}`])}>{React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}</div>
			</div>
		</FilteredListContext.Provider>
	);
}

AcfFilteredList.fragments = {
	key: `AcfFilteredListFragment`,
	entry: gql`
		fragment AcfFilteredListFragment on AcfFilteredList {
			attributes {
				anchor
				className
        alignContent
			}
			filteredList {
				columns {
          mobile
          desktop
        }
				filterButtons {
					slug
					label
				}
				allowMultipleFilters
			}
		}
	`,
};

AcfFilteredList.config = {
	name: 'AcfFilteredList',
};
AcfFilteredList.displayName = 'AcfFilteredList';
